import { Typography } from '@mui/material'
import parse from 'html-react-parser'
import rehypeStringify from 'rehype-stringify'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import { unified } from 'unified'
import './FormTypography.scss'

export const FormHelptext = ({ helpText, parseToHtml, parseLabel }) => {
  if (!helpText) {
    return <div />
  } else if (parseToHtml) {
    helpText = unified()
      .use(remarkParse)
      .use(remarkRehype, { allowDangerousHtml: true })
      .use(rehypeStringify, { allowDangerousHtml: true })
      .processSync(helpText)
      .toString()
  }

  return (
    <Typography
      className='form-help-text'
    >
      {parseLabel || parseToHtml ? parse(helpText) : helpText}
    </Typography>
  )
}
